/* import __COLOCATED_TEMPLATE__ from './action-buttons-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();